import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaA_Hatchback_Right: React.FC<AreaSVGProps> = ({
  fill = '#EE2A2A',
  stroke = '#EE2A2A',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="94"
      height="132"
      viewBox="0 0 94 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_hatchback_right"
          x="0"
          y="0"
          width="94"
          height="132"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_a_hatchback_right)">
        <path
          d="M28.1719 4.07357e-06C27.1248 0.835154 26.1703 1.53268 25.3477 2.09571C24.2008 2.96649 22.7842 3.57106 21.1934 3.58594C19.5252 3.60149 18.0452 2.96359 16.9102 1.98243C16.7344 1.83052 16.5686 1.67039 16.4102 1.50489C16.2275 2.23852 16.0534 2.9627 15.8877 3.66797C10.5881 26.2907 4.19599 81.049 0 129.881C30.9203 124.697 68.4833 126.715 92.9834 131.408C92.9879 131.327 92.9925 131.245 92.9971 131.162C93.0652 129.919 93.1321 128.561 93.1924 127.256C73.7153 125.723 57.6539 121.095 45.7666 111.613C32.9529 101.393 25.5861 86.022 23.4727 64.6084L23.457 64.4531L23.4541 64.2969C23.1543 49.662 25.1554 35.2103 34.0205 21.1123L28.1719 4.07357e-06Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
